import React, { useState, useEffect } from 'react';
import { DeleteEntityTypes } from '@Shared.Angular/flowingly.services/flowingly.constants';
import './RunnerSetupDeleteWarnings.scss';

type Props = {
  entityName: string;
  warnings: string[];
  deleteConfirmed: (confirmed: boolean) => void;
  entityType: DeleteEntityTypes;
};

export const RunnerSetupDeleteWarnings = ({
  entityName,
  warnings,
  deleteConfirmed,
  entityType
}: Props) => {
  const [usersConfirmationInput, setUsersConfirmationInput] = useState('');
  const targetConfirmationPhrase = 'delete';
  const showNoUndoMessage = entityType !== DeleteEntityTypes.flowModelEntityType;

  useEffect(() => {
    const confirmed = usersConfirmationInput.toLowerCase() === targetConfirmationPhrase;
    deleteConfirmed(confirmed);
  }, [usersConfirmationInput, deleteConfirmed]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUsersConfirmationInput(event.target.value);
  };

  return (
    <fieldset className="runner-setup-delete-warnings">
      <legend>Warning</legend>
      <div className="delete-warnings">
        <p>
          You are about to delete <b>{entityName}</b>.
        </p>
        {showNoUndoMessage && <p>This cannot be undone!</p>}
        <div className="delete-warnings-container">
          {warnings.length > 0 && (
            <ul>
              {warnings.map((warning, index) => (
                <li key={index}>
                  <i className="fa-light fa-triangle-exclamation mb-2" aria-hidden="true"></i>
                  {warning}
                </li>
              ))}
            </ul>
          )}
        </div>

        <label>
          Type <b>DELETE</b> to continue
        </label>
        <div className="input-field col s12">
          <input
            className="text-box"
            type="text"
            value={usersConfirmationInput}
            required
            onChange={handleInputChange}
            data-testid="confirm-delete-input"
          />
        </div>
      </div>
    </fieldset>
  );
};
